export type FcItemModalContext = FcNewModal | FcModifyModal;

export interface FcItemModalContextBase {
  mode: FcItemModalMode;
  findControlId: string;
  findControlName: string;
}
export interface FcNewModal extends FcItemModalContextBase {
  mode: FcItemModalMode.New;
}

export interface FcModifyModal extends FcItemModalContextBase {
  mode: FcItemModalMode.Modify;
  selectedFindItemPk: string;
  selectedFindItemName: string;
}
export enum FcItemModalMode {
  Modify,
  New,
}
